module.exports = __webpack_public_path__ + "static/img/nose_07.8c25a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/noses/thumbnail/nose_07.png
// module id = ekmp
// module chunks = 0